import React from 'react';

const Row = ({ item }) => {
    return (
        <tr>
            <td> {item.crsnNumE}</td>
            <td> {item.crsName} </td>
            <td>{item.crsHours}</td>
            <td>{item.grade}</td>
            <td>{item.points}</td>
            <td>{item.creditAcheived}</td>
            <td></td>

        </tr >
    )
}

export default Row;


// WEBPACK FOOTER //
// ./src/pages/Transcript/Row.js